import { useMemo, useState } from 'react'
import { Link, Navigate, useParams } from 'react-router-dom'

import {
  carriersViewLayerPath,
  isCarriersViewLayer,
  parseCarriersViewLayer,
} from './carriersViewLayers.js'
import {
  DocumentTypesTable,
  documentCarrierSupport,
} from './DocumentTypesTable.js'
import { carrierSupport, EngineLayersTable } from './EngineLayersTable.js'
import { matchesCarrierSearch } from './matchesCarrierSearch.js'

const CarriersView = () => {
  const { layer: layerParam } = useParams()
  const layer = parseCarriersViewLayer(layerParam)
  const [search, setSearch] = useState('')

  const engineMatchCount = useMemo(
    () =>
      carrierSupport.filter(carrier => matchesCarrierSearch(carrier, search))
        .length,
    [search],
  )

  const documentMatchCount = useMemo(
    () =>
      documentCarrierSupport.filter(carrier =>
        matchesCarrierSearch(carrier, search),
      ).length,
    [search],
  )

  const activeCount = layer === 'layers' ? engineMatchCount : documentMatchCount
  const totalCount =
    layer === 'layers' ? carrierSupport.length : documentCarrierSupport.length

  if (!isCarriersViewLayer(layerParam)) {
    return <Navigate to="/carriers" replace />
  }

  return (
    <div className="flex flex-col h-screen bg-base-200 text-base-content p-6 overflow-hidden">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-2xl font-bold">Carrier Support</h1>
        <span className="text-sm opacity-70">
          {activeCount} of {totalCount} carriers
        </span>
      </div>

      <div role="tablist" className="tabs tabs-border mb-4 w-fit">
        <Link
          role="tab"
          to={carriersViewLayerPath('layers')}
          className={`tab ${layer === 'layers' ? 'tab-active' : ''}`}
        >
          Engine layers
        </Link>
        <Link
          role="tab"
          to={carriersViewLayerPath('documents')}
          className={`tab ${layer === 'documents' ? 'tab-active' : ''}`}
        >
          Document types
        </Link>
      </div>

      <p className="mb-4 text-sm opacity-70">
        {layer === 'layers'
          ? 'Carriers and the engine layers that support them.'
          : 'Carriers with a files provider and canonical document types they may return.'}
      </p>

      <label className="input input-bordered flex items-center gap-2 mb-4 max-w-sm">
        <input
          type="text"
          className="grow"
          placeholder="Search by name or SCAC..."
          value={search}
          onChange={event => setSearch(event.target.value)}
        />
      </label>

      {layer === 'layers' ? (
        <EngineLayersTable search={search} />
      ) : (
        <DocumentTypesTable search={search} />
      )}
    </div>
  )
}

export { CarriersView }
